export default __webpack_public_path__ + "static/pexels-pixabay-158385-5deb91af53606013ee9f830f49d2bf83.jpg";